module.exports = Function.call.bind(Object.prototype.hasOwnProperty);



// WEBPACK FOOTER //
// ./~/react/~/prop-types/lib/has.js